/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React, { useEffect, useRef } from "react";

import { LoaderLayout } from "../../components/atoms/loader/LoaderLayout";
import { useOidcBridge } from "./useOidcBridge";

/**
 * auth-op へ本人確認を受け渡す
 *
 * ユーザーの操作は挟まない。コードが揃ったら form を自動送信する。
 * コードは URL に載せない（履歴とアクセスログに残るため）。
 */
export const OidcBridge: React.FC = () => {
  const { t } = useI18n();
  const status = useOidcBridge();
  const form = useRef<HTMLFormElement>(null);

  /**
   * 送信を1回に固定する
   *
   * 二度送るとコードが消費済みになり、auth-opはinteractionの結果を
   * access_deniedで上書きしてしまう。RPには「ログインが完了しなかった」としか
   * 伝わらず、原因が分かりにくい。
   */
  const submitted = useRef(false);

  /** `t` は毎レンダリング新しい関数になるため、依存には値を渡す */
  const errorMessage = t("auth.error");

  useEffect(() => {
    if (status.type === "submitting" && !submitted.current) {
      submitted.current = true;
      form.current?.submit();
    }
    if (status.type === "error") window.alert(errorMessage);
  }, [status, errorMessage]);

  if (status.type === "submitting") {
    return (
      <form ref={form} method="post" action={status.action}>
        <input type="hidden" name="code" value={status.code} />
      </form>
    );
  }

  /**
   * 失敗しても auth-op へは戻れないため、ここでやり直す導線は出せない。
   * ローディングのまま止めると操作不能になるので、状況だけ伝える。
   * `auth.error2` は文言に `<br/>` を含み t() では実体が出るため使わない
   */
  if (status.type === "error") {
    return <p>{errorMessage}</p>;
  }

  return <LoaderLayout />;
};
